export default __webpack_public_path__ + "static/media/shopping-cart.bd9fe5a2.jpg";